<h2 mat-dialog-title>
  <div class="dialog-title" fxLayout="column" fxLayoutAlign="space-between" fxFlex="100">
    <div fxLayout="row" fxLayoutAlign="space-between" fxFlex="100">
      <span>Add Custom Item</span>
      <mat-icon (click)="reference?.close()">close</mat-icon>
    </div>
    <span class="subtitle">
      Please keep in mind that any small items should not be added as a custom item individually. Please try and search for your item first.
    </span>
  </div>
</h2>

<div fxLayout="column" mat-dialog-content style="padding-top: 30px">
  <div fxLayout="column" [ngClass]="{ 'captain-app': environment.isCaptain }">
    <div fxLayout="column" class="custom-item-name" fxLayoutGap="6px">
      <mat-label [ngClass]="{ invalid: !name.valid && name.dirty }">Name *</mat-label>
      <input [formControl]="name" matInput autocomplete="off" />
    </div>
    <div fxFlex fxLayout="column">
      <mat-label>Size *</mat-label>
      <mat-radio-group [(ngModel)]="size" fxLayout="column" class="size-picker">
        <mat-radio-button disabled value="small">Small</mat-radio-button>
        <mat-radio-button value="medium">
          Medium
          <span class="cat-description">1 person lift</span>
        </mat-radio-button>
        <mat-radio-button value="large">
          Large
          <span class="cat-description">2 person lift</span>
        </mat-radio-button>
        <mat-radio-button value="xlarge">
          X-Large
          <span class="cat-description">2+ person lift / special equipment</span>
        </mat-radio-button>
      </mat-radio-group>
    </div>
    @if (size === 'xlarge') {
      <div>
        <h5>Disassembly options</h5>
        <mat-radio-group [(ngModel)]="disassembly" name="disassemblyOptions" ngDefaultControl class="disassembly-radio-group">
          <mat-radio-button class="disassembly-option" [value]="true" labelPosition="before">
            <div class="option-content">
              <div class="option-title">Let Resupply Disassemble</div>
              <div class="option-subtitle">Resupply does offer professional disassembly for a fee</div>
            </div>
          </mat-radio-button>

          <mat-radio-button class="disassembly-option" [value]="false" labelPosition="before">
            <div class="option-content">
              <div class="option-title">No disassembly needed</div>
              <div class="option-subtitle">free</div>
            </div>
          </mat-radio-button>
        </mat-radio-group>
      </div>
    }

    <div class="actions" fxLayout="row" fxLayoutAlign="space-between">
      <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
        <span class="label no-mobile">Quantity</span>
        <div class="counter-controls" fxLayout="row" fxLayoutAlign="space-between">
          <div class="counter-btn" (click)="removeItem()" [ngClass]="{ disabled: count === 1 }">
            <mat-icon>remove</mat-icon>
          </div>
          <input type="tel" [(ngModel)]="count" (input)="handleQuantityChangeThroughInput($event)" />
          <div class="counter-btn" (click)="addItem()">
            <mat-icon>add</mat-icon>
          </div>
        </div>
      </div>
      <button
        class="primary-btn filled-btn"
        fxLayout="row"
        fxLayoutAlign="center center"
        fxLayoutGap="10px"
        [disabled]="!name.valid || !size"
        (click)="submit()"
      >
        Add
        <mat-icon svgIcon="ss3-arrow-right" />
      </button>
    </div>
  </div>
</div>
